import { render } from "./natureEventClub.vue?vue&type=template&id=0173cb42"
import script from "./natureEventClub.vue?vue&type=script&lang=js"
export * from "./natureEventClub.vue?vue&type=script&lang=js"

import "./natureEventClub.vue?vue&type=style&index=0&id=0173cb42&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__